import { Routes } from "@angular/router";
import { CreateGroupComponent } from "src/app/groups/create-group/create-group.component";
import { JoinCompletedComponent } from "src/app/groups/join-completed/join-completed.component";
import { JoinGroupComponent } from "src/app/groups/join-group/join-group.component";
import { GroupinfoComponent } from "src/app/order/groupinfo/groupinfo.component";

export const GROUPS_ROUTES: Routes = [
   {
      path: 'group/join', component: JoinGroupComponent
   },
   {
      path: 'group/completed/:orderNumber', component: JoinCompletedComponent
   },
   {
      path: 'group/create/:id/:sku/:quantity', component: CreateGroupComponent
   },
   {
      path: 'group/:uuid', component: GroupinfoComponent
   },
]